var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function forEachName(object, map) {
    return Object.keys(object)
        .map(function (key) { return ({ key: key, value: map(key) }); })
        .reduce(function (acc, line) {
        var _a;
        return (__assign({}, acc, (_a = {}, _a[line.key] = line.value, _a)));
    }, {});
}
export function getMaxMatch(mediaRules, matches) {
    var keys = Object.keys(mediaRules);
    var len = keys.length;
    var index = 0;
    for (; index < len; index++) {
        if (matches[keys[index]]) {
            break;
        }
    }
    return keys[index];
}
function validateSlots(rules, slots) {
    if (
    // @ts-ignore
    process.env.NODE_ENV !== 'production') {
        // validate slots versus rules
        Object.keys(slots).forEach(function (slotKey) {
            if (rules.indexOf(slotKey) < 0) {
                throw new Error('react-media-match: used slot [' +
                    slotKey +
                    '] is not among [' +
                    rules.join(',') +
                    ']. This is a development error only');
            }
        });
    }
}
export function pickMediaMatch(mediaRules, matches, slots, defaultValue) {
    var keys = Object.keys(mediaRules);
    var len = keys.length;
    validateSlots(keys, slots);
    var index = 0;
    for (; index < len; index++) {
        if (matches[keys[index]]) {
            break;
        }
    }
    for (; index >= 0; index--) {
        var value = slots[keys[index]];
        if (value !== undefined) {
            return value;
        }
    }
    // could be only possible if no slots is given, so K is undefined
    return defaultValue;
}
export function pickMatchValues(points, props) {
    var keys = Object.keys(points);
    validateSlots(keys, props);
    return keys.reduce(function (acc, key) {
        if (points[key] !== undefined) {
            acc[key] = props[key];
        }
        return acc;
    }, {});
}
export function inBetween(breakPoints, points, value, invert, include) {
    var keys = Object.keys(breakPoints);
    var pass = false;
    validateSlots(keys, points);
    return Object.keys(breakPoints).reduce(function (acc, key) {
        if (invert && points[key]) {
            pass = true;
        }
        acc[key] = (include ? pass : !pass) ? null : value;
        if (!invert && points[key]) {
            pass = true;
        }
        return acc;
    }, {});
}
export function nothingSet(matches) {
    return Object.keys(matches).reduce(function (acc, key) {
        acc[key] = false;
        return acc;
    }, {});
}
export function notNulls(matches) {
    return Object.keys(matches).reduce(function (acc, key) {
        if (matches[key] !== undefined) {
            acc[key] = matches[key];
        }
        return acc;
    }, {});
}
